import { render, staticRenderFns } from "./stand.vue?vue&type=template&id=38c2d31e&scoped=true&"
import script from "./stand.vue?vue&type=script&lang=js&"
export * from "./stand.vue?vue&type=script&lang=js&"
import style0 from "./stand.vue?vue&type=style&index=0&id=38c2d31e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2d31e",
  null
  
)

export default component.exports